import * as React from 'react';
import { Card } from '..';
import { Text, TextTypography } from '../Text';
import { st, classes } from './CardWiringExample.st.css';
import { ImageResizeOptions, ThumbnailImage } from '../ThumbnailImage';

const loremIpsum =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat';

export const CardWiringExample = () => {
  return (
    <Card className={st(classes.root)}>
      <Card.Container className={classes.media}>
        <ThumbnailImage
          src="https://static.wixstatic.com/media/c5f754_23cf5dfa1ea44dc09e87a03df0996f83~mv2.png/v1/fill/w_400,h_520,al_c/c5f754_23cf5dfa1ea44dc09e87a03df0996f83~mv2.png"
          alt="My product"
          width={400}
          height={520}
          fluid
          resize={ImageResizeOptions.cover}
        />
      </Card.Container>
      <Card.Container className={classes.info}>
        <>
          <Text typography={TextTypography.smallTitle} tagName="h3">
            My Product
          </Text>
          <Text typography={TextTypography.runningText}>{loremIpsum}</Text>
        </>
      </Card.Container>
    </Card>
  );
};
CardWiringExample.displayName = 'CardWiringExample';
